import React, { forwardRef } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import styles from "./Badge.scss";

const BadgeParagraph = forwardRef(({ children, fonts, ...restProps }, ref) => {
  return (
    <span className={cx(styles.paragraph, fonts)} ref={ref} {...restProps}>
      {children}
    </span>
  );
});

BadgeParagraph.propTypes = {
  fonts: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

BadgeParagraph.defaultProps = {
  fonts: styles.additionalHighlight,
};

BadgeParagraph.Font = {
  secondary: styles.secondaryHeading,
  secondaryUppercase: styles.secondaryHeadingUppercase,
  tertiary: styles.tertiaryHeading,
  tertiaryUppercase: styles.tertiaryHeadingUppercase,
  quaternary: styles.quaternaryHeading,
  quaternaryUppercase: styles.quaternaryHeadingUppercase,
  copyHighlight: styles.copyHighlight,
  additional: styles.additional,
  additionalHighlight: styles.additionalHighlight,
  rectangleAdditional: styles.rectangleAdditional,
  rectangleSecond: styles.rectangleFontSecond,
  rounded: styles.fontRounded,
  roundedBasic: styles.roundFontBasic,
  roundedSecond: styles.roundFontSecond,
  roundedThird: styles.roundFontThird,
  roundedFourth: styles.roundFontFourth,
  uppercase: styles.uppercase,
};

BadgeParagraph.displayName = "Badge.Paragraph";

export default BadgeParagraph;
